import { render, staticRenderFns } from "./ElementCorrectionTableColumn.vue?vue&type=template&id=9931a9ba"
import script from "./ElementCorrectionTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementCorrectionTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports